import { computed, effect, inject, Injectable } from '@angular/core';
import { ScreenSize, sidebarEvents, UIStore } from '@easihub/ngx';
import { Dispatcher } from '@ngrx/signals/events';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  constructor() {
    this.updateState();
  }

  private readonly ui = inject(UIStore);
  private readonly dispatcher = inject(Dispatcher);

  readonly layout$ = this.ui.layout;
  readonly navigating$ = this.ui.navigating;
  readonly screenSize$ = this.ui.screenSize;


  readonly state = (() => {
    const { visible, expanded } = this.ui.sidebar;

    const mode$ = computed(() => {
      return visible() ? 'side' : 'over';
    });
    const opened$ = expanded;

    return { mode$, opened$ } as const;
  })();

  private updateState() {
    const largeScreenSizes: ScreenSize[] = ['7xl', '8xl', '9xl', '10xl'];

    const alwaysShowSideMenu$ = computed(() =>
      this.layout$() === 'full' &&
      largeScreenSizes.includes(this.screenSize$())
    );

    effect(() => {
      const layout = this.layout$();

      if (layout === 'minimal') {
        this.dispatcher.dispatch(sidebarEvents.hide());
        this.dispatcher.dispatch(sidebarEvents.close());
      }
      else {
        const alwaysShowSideMenu = alwaysShowSideMenu$();
        if (alwaysShowSideMenu) {
          this.dispatcher.dispatch(sidebarEvents.show());
          this.dispatcher.dispatch(sidebarEvents.open());
        }
        else {
          this.dispatcher.dispatch(sidebarEvents.hide());
          this.dispatcher.dispatch(sidebarEvents.close());
        }
      }

    });
  }
}
